import React, { Component } from "react";
import { withFirestore, firebaseConnect, isEmpty } from "react-redux-firebase";
import { compose } from "redux";
import { addTestComment } from "./TestDetailPageActions";
import { connect } from "react-redux";
import { Grid } from "semantic-ui-react";
import TestDetailHeader from "./TestDetailHeader";
import TestDetailInfo from "./TestDetailInfo";
import TestDetailChat from "./TestDetailChat";
import TestDetailSidebar from "./TestDetailSidebar";
import {
  selectedCategory,
  selectedTest
} from "../../features/selections/selectActions";
import { createTestTree } from "../../features/userTestTree/userTestTreeActions";
import firebase from "firebase";
import "firebase/firestore";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import { objectToArray, createDataTree } from "../UserDetail/helper";

const actions = {
  selectedTest,
  selectedCategory,
  addTestComment,
  createTestTree
};

const mapState = state => {
  return {
    auth: state.firebase.auth,
    selectedCollection: state.selection.selectedCategory,
    selectedTestId: state.selection.selectedTest,
    testTree: state.userTestTreeReducer.testTree,
    testChat:
      !isEmpty(state.firebase.data.test_chat) &&
      objectToArray(
        state.firebase.data.test_chat[
          `${state.selection.selectedCategory}_${state.selection.selectedTest}`
        ]
      )
  };
};

class TestDetailPage extends Component {
  state = {
    loading: true
  };
  documentSnapshot = {};
  attendeeListSnapShot = {};
  attendeeList = [];

  async componentDidMount() {
    const {
      selectedCollection,
      createTestTree,
      selectedTestId,
      auth
    } = this.props;

    // if (this.props.location.query) {
    //     this.documentSnapshot = this.props.location.query.value;
    //     console.log(
    //         "location query value at details ",
    //         this.props.location.query.value
    //     );
    // }

    if (selectedTestId !== "") {
      try {
        this.documentSnapshot = await firebase
          .firestore()
          .collection(selectedCollection)
          .doc(selectedTestId)
          .get();
        // console.log("TestDetailPage doc ", this.documentSnapshot);
        this.setState({
          loading: false
        });
      } catch (error) {
        console.log("Fetching error ", error);
      }

      try {
        this.attendeeListSnapShot = await firebase
          .firestore()
          .collection(selectedCollection)
          .doc(selectedTestId)
          .collection("attendees")
          .orderBy("testScore", "desc")
          .get();

        // console.log(
        //     "attendeeListSnapShot is ",
        //     this.attendeeListSnapShot.docs[0].data()
        // );
        // console.log(
        //     "attendeeListSnapShot id ",
        //     this.attendeeListSnapShot.docs[0].id
        // );

        for (let i = 0; i < this.attendeeListSnapShot.docs.length; i++) {
          let obj = {
            id: this.attendeeListSnapShot.docs[i].id,
            values: this.attendeeListSnapShot.docs[i].data()
          };
          this.attendeeList.push(obj);
          console.log("attendeeList ", this.attendeeList);
        }
      } catch (error) {
        console.log("createTestTree() failed", error);
      }

      try {
        await createTestTree(auth.uid);
      } catch (error) {
        console.log("createTestTree() failed", error);
      }
    } else {
      this.props.history.push("/error");
    }
  }

  objectToArray = object => {
    if (object) {
      return Object.entries(object).map(e => Object.assign(e[1], { id: e[0] }));
    }
  };

  handleRating = async (e, { rating, maxRating }) => {
    console.log("handleRating() clicked ", rating);
    try {
      let totalRating = this.documentSnapshot.data().rating;
      let newRating = rating;
      totalRating[this.props.auth.uid] = newRating;
      let obj = totalRating;
      let avgRating = 0;
      if (Object.entries(obj).length > 0) {
        let counter = 0;
        let values = 0;
        Object.keys(obj).forEach(key => {
          values += obj[key];
          counter++;
          //use key and value here
          console.log("values ", values);
        });
        console.log("avg rating ", values / counter);
        avgRating = Math.round(values / counter);
      }

      await firebase
        .firestore()
        .collection(this.props.selectedCollection)
        .doc(this.props.selectedTestId)
        .update({
          rating: totalRating,
          avgRating
        });
    } catch (error) {
      console.log("update rating error ", error);
    }
  };

  render() {
    const {
      testChat,
      addTestComment,
      selectedCollection,
      selectedTestId,
      auth
    } = this.props;
    const chatTree = !isEmpty(testChat) && createDataTree(testChat);
    const userId = auth.uid;
    if (this.state.loading) return <LoadingComponent inverted={true} />;
    // const attendees =
    //     this.documentSnapshot.data().attendees &&
    //     this.objectToArray(this.documentSnapshot.data().attendees);

    const avgScore =
      Math.floor(this.documentSnapshot.data().avgScore * 100) / 100;
    const testScore = this.documentSnapshot.data().attendees[userId]
      ? this.documentSnapshot.data().attendees[userId].testScore
      : 0;
    // const testScore = 0;
    const avgRating = this.documentSnapshot.data().avgRating;
    const totalUser = Object.entries(this.documentSnapshot.data().rating)
      .length;

    // console.log("user id ", userId);
    // console.log(
    //     "test score ",
    //     this.documentSnapshot.data().attendees[userId].testScore
    // );

    // console.log("attendees ", attendees);
    return (
      <Grid stackable>
        <Grid.Column width={10}>
          <TestDetailHeader />
          <TestDetailInfo
            avgScore={avgScore}
            testScore={testScore}
            handleRating={this.handleRating}
            rating={avgRating}
            totalUser={totalUser}
          />
          <TestDetailChat
            testChat={chatTree}
            addTestComment={addTestComment}
            testId={selectedTestId}
            testCollection={selectedCollection}
          />
        </Grid.Column>
        <Grid.Column width={6}>
          <TestDetailSidebar attendees={this.attendeeList} />
        </Grid.Column>
      </Grid>
    );
  }
}

// export default connect(
//     mapState,
//     actions
// )(TestDetailPage);

export default compose(
  withFirestore,
  connect(
    mapState,
    actions
  ),
  firebaseConnect(props => [
    `test_chat/${props.selectedCollection}_${props.selectedTestId}`
  ])
)(TestDetailPage);
